import axios from 'axios';
import apiconfig from '../../apiconfig';

export default async ({ Vue }) => {
  const config = apiconfig[process.env.NODE_ENV];

  axios.defaults.baseURL = config.url;
  axios.defaults.timeout = 120000;
  axios.defaults.headers.common['Accept-Version'] = apiconfig.apiVersion;
  axios.defaults.headers.common['X-Access-Token'] = config.accessToken;
  Vue.prototype.$axios = axios;
};
